import "../styles/footer.scss"
const Footer = () => {

    return ( 
        <section className="footer">
              <p>Copyright  &copy; 2022 Dali Ben Helal All rights reserved</p>
        </section>
    );
}
 
export default Footer;